var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExtra(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0059 19.34C24.0059 22.1014 21.7673 24.34 19.0059 24.34C16.2444 24.34 14.0059 22.1014 14.0059 19.34C14.0059 16.5785 16.2444 14.34 19.0059 14.34C21.7673 14.34 24.0059 16.5785 24.0059 19.34ZM19.0059 16.5622C19.3127 16.5622 19.5614 16.8109 19.5614 17.1177V18.7844H21.2281C21.5349 18.7844 21.7836 19.0331 21.7836 19.34C21.7836 19.6468 21.5349 19.8955 21.2281 19.8955H19.5614V21.5622C19.5614 21.869 19.3127 22.1177 19.0059 22.1177C18.699 22.1177 18.4503 21.869 18.4503 21.5622V19.8955H16.7836C16.4768 19.8955 16.2281 19.6468 16.2281 19.34C16.2281 19.0331 16.4768 18.7844 16.7836 18.7844H18.4503V17.1177C18.4503 16.8109 18.699 16.5622 19.0059 16.5622Z",
    fill: "#222729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2559 2.33997H5.25586C3.46093 2.33997 2.00586 3.79504 2.00586 5.58997V19.09C2.00586 20.8849 3.46093 22.34 5.25586 22.34H11.2559L11.2559 2.33997ZM9.00586 10.34C8.45357 10.34 8.00586 10.7877 8.00586 11.34V13.34C8.00586 13.8923 8.45357 14.34 9.00586 14.34C9.55814 14.34 10.0059 13.8923 10.0059 13.34V11.34C10.0059 10.7877 9.55814 10.34 9.00586 10.34Z",
    fill: "#CFD6D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0059 12.34C16.2752 12.34 13.9097 13.9035 12.7559 16.1842L12.7559 2.33997H18.7559C20.5508 2.33997 22.0059 3.79504 22.0059 5.58997V13.0136C21.0966 12.5817 20.0795 12.34 19.0059 12.34Z",
    fill: "#CFD6D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExtra);
export default __webpack_public_path__ + "static/media/icon-extra.cc511a82b08c5d11393c5a7b11c13814.svg";
export { ForwardRef as ReactComponent };